export default __webpack_public_path__ + "static/B0256-642b80ff958ff6a277cf130024dfa882.png";